import FAQs from './FAQs.json'
import aboutUs from './aboutUs.json'
import articleCategories from './articleCategories.json'
import articles from './articles.json'
import comments from './comments.json'
import counselings from './counselings.json'
import feedback from './feedback.json'
import dashboard from './dashboard.json'
import errors from './errors.json'
import general from './general.json'
import login from './login.json'
import managerCategories from './managerCategories.json'
import momExperiences from './momExperiences.json'
import managers from './managers.json'
import notifications from './notifications.json'
import pageCategories from './pageCategories.json'
import pages from './pages.json'
import permissions from './permissions.json'
import questions from './questions.json'
import roles from './roles.json'
import serviceCategories from './serviceCategories.json'
import services from './services.json'
import specialists from './specialists.json'
import suggestions from './suggestions.json'
import tags from './tags.json'
import testimonials from './testimonials.json'
import themeSettings from './themeSettings.json'
import users from './users.json'
import validator from './validator.json'
import videos from './videos.json'
import weeks from './weeks.json'
import unit from './unit.json'

export default {
  FAQs,
  feedback,
  aboutUs,
  articleCategories,
  articles,
  comments,
  counselings,
  dashboard,
  errors,
  general,
  login,
  managerCategories,
  managers,
  momExperiences,
  notifications,
  pageCategories,
  pages,
  permissions,
  questions,
  roles,
  serviceCategories,
  services,
  specialists,
  suggestions,
  tags,
  testimonials,
  themeSettings,
  users,
  validator,
  videos,
  weeks,
  unit,
}
